import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const useEditableContent = (content, preview) => {
  const [pageContent, setPageContent] = useState(content);
  const [ready, setReady] = useState(false);
  const router = useRouter();

  const handleSetPageContent = (newContent) => {
    setPageContent({ ...pageContent, ...newContent });
  };

  useEffect(() => {
    setPageContent(content);
  }, [content]);

  useEffect(() => {
    if (window.storyblok) {
      window.storyblok.init({
        accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
      });

      window.storyblok.on(['change', 'published'], (event) => {
        if (!event.slugChanged) {
          router.reload();
        }
      });

      window.storyblok.pingEditor(() => {
        if (window.storyblok.isInEditor()) {
          console.log('we are in the editor');
          window.storyblok.enterEditmode();
        }
      });

      window.storyblok.on('input', (event) => {
        if (event.story.content._uid === pageContent._uid) {
          window.storyblok.addComments(event.story.content, event.story.id);
          handleSetPageContent(event.story.content);
        }
      });
    }
  }, [ready, content]);

  useEffect(() => {
    if (preview && !window.storyblok) {
      let script = document.createElement('script');
      script.src = `//app.storyblok.com/f/storyblok-latest.js?t=process.env.NEXT_PUBLIC_STORYBLOK_TOKEN`;
      document.body.appendChild(script);

      script.onload = () => {
        setReady(true);
      };
    }
    if (preview && window.storyblok) {
      setReady(true);
    }
  }, [preview]);

  return pageContent;
};

export default useEditableContent;
